import { render } from "./BlogHollywoodSmileLongevity.vue?vue&type=template&id=70e30635"
import script from "./BlogHollywoodSmileLongevity.vue?vue&type=script&lang=js"
export * from "./BlogHollywoodSmileLongevity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__